import { createFileRoute } from '@tanstack/react-router';
import { CalibracaoParsingPage } from '@/features/admin/tribunais/CalibracaoParsingPage';

export const Route = createFileRoute('/admin/tribunais/$tribunalId/calibracao')({
  component: CalibracaoParsingRoute,
});

function CalibracaoParsingRoute() {
  const { tribunalId } = Route.useParams();
  return <CalibracaoParsingPage tribunalId={tribunalId} />;
}
